import React, { useState } from 'react'
import { TicketCards } from './TicketCards'
import { TicketTablesdash } from './TicketTablesdash'

export const Ticketlist = (
  {
       datas,
  PriorityValues,
  SttausValues,
  Client,
  range,
  date
  }
) => {

   
    const [activeButton, setActiveButton] = useState("Open");

  const handleButtonClick = (button) => {
    setActiveButton(button);
  };
  const HandletheActived = (tab) => {
    setActiveButton(tab);
  }


  return (
    <>

<div>
  <TicketCards activeButton={activeButton} setActiveButton={setActiveButton} handleButtonClick={handleButtonClick} />


        <div className="row TicketTable_ TicketTables" >
          <TicketTablesdash setActiveButton={setActiveButton} activeButton={activeButton} HandletheActived={HandletheActived}
                    datas={datas}
  PriorityValues={PriorityValues}
  SttausValues={SttausValues}
  Client={Client}
range={range} 
  date={date}
  
          
          />

        </div>
</div>
    </>
  )
}
